import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '500px',
    maxWidth: '100%',
    marginBottom: theme.spacing(2.5),
  },
  taskDetails: {
    display: 'flex',
    color: '#8a8a8a',
  },
  taskDetailsText: {
    fontSize: '14px',
  },
}));
